import React from 'react';

import uniqloVideo from '../content/video.mov';
import newBalanceVideo from '../content/video2.mov';
import onCloudVideo from '../content/video3.mov';
import hmVideo from '../content/video4.mov';

const localVideos = [
  {
    src: uniqloVideo,
    title: 'Видеоурок Uniqlo',
    description: 'Видеоурок по регистрации на сайт Uniqlo для совершения заказов',
  },
  {
    src: newBalanceVideo,
    title: 'Видеоурок New Balance',
    description: 'Видеоурок по регистрации на сайт New Balance для совершения заказов',
  },
  {
    src: onCloudVideo,
    title: 'Видеоурок OnCloud',
    description: 'Видеоурок по регистрации на сайт OnCloud для совершения заказов',
  },
  {
    src: hmVideo,
    title: 'Видеоурок HM',
    description: 'Видеоурок по регистрации на сайт HM для совершения заказов',
  }
];

const VideosPage = () => {
  return (
    <div className="min-h-screen bg-bg text-text-primary pb-20">
      <div className="px-4 pt-6 max-w-5xl mx-auto">
        <h1 className="text-xl font-semibold tracking-tight">Видео материалы</h1>
        <p className="mt-2 text-sm text-text-secondary">Инструкции по работе с японскими сайтами и доставкой</p>

        <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4">
          {localVideos.map((v) => (
            <div key={v.src} className="rounded-2xl border border-stroke bg-surface backdrop-blur-md overflow-hidden">
              <div className="aspect-video bg-black/30">
                <video src={v.src} className="w-full h-full" controls playsInline preload="metadata" />
              </div>
              <div className="p-4">
                <div className="font-semibold text-text-primary">{v.title}</div>
                {v.description && <div className="mt-1 text-sm text-text-secondary">{v.description}</div>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VideosPage;

